// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__JbWVs","divider__large":"divider_divider__large__Bjlqx"};